/* eslint-disable import/prefer-default-export -- getSubscriptionTier is a standalone utility exported for reuse */
import { UserRole } from "@next-platform/packages-ts-types";
import { SubscriptionTiers, UserRoles } from "../features";
export const getSubscriptionTier = (role) => {
    switch (role) {
        case UserRoles.PREMIUM:
        case UserRole.SM_PREMIUM:
            return SubscriptionTiers.PREMIUM;
        case UserRoles.BASIC:
        case UserRole.SM_BASIC:
            return SubscriptionTiers.BASIC;
        case UserRoles.MINIMAL:
            return SubscriptionTiers.MINIMAL;
        default:
            return SubscriptionTiers.FREE;
    }
};
